<div class="" [ngClass]="emailBodyContainer">
    <form [formGroup]="bodyForm" (ngSubmit)="onSubmit()">
        <!-- Modal Header -->
        <div class="modal-header">
            <h4 class="modal-title">Edit Email Body</h4>
            <button type="button" class="close" data-dismiss="modal" (click)="cancel()">
                <i class="icon-close"></i>
            </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
            <div class="modal-body-inner">
                <div class="row">
                    <div class="col">
                        <label>Email Body</label>
                        <div [ngxSummernote]="config"
                            [ngClass]="{ 'is-invalid': (bodyForm.controls['body']?.invalid && bodyForm.controls['body']?.touched || submitted) || f.body?.errors?.apiError, 'is-valid' : !(bodyForm.controls['body']?.invalid)}"
                            formControlName="body"></div>
                        <span class="invalid-feedback" role="alert"
                            *ngIf="(bodyForm.controls['body']?.invalid && bodyForm.controls['body']?.touched || submitted) || f.body?.errors?.apiError">
                            <span *ngIf="f.body?.errors?.required">Enter email body.</span>
                            <span *ngIf="f.body?.errors?.apiError">{{f.body?.errors?.apiError}}</span>
                        </span>
                    </div>
                </div>

                <div class="row">
                    <p class="hint-section"><b>Note</b>: {{this.emailModel?.hint}} </p>
                </div>
            </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button" class="dark-bordered-btn dont-send-btn" data-dismiss="modal"
                (click)="cancel()">Cancel</button>
            <button type="button" class="submit-btn-grey status-modal-save" (click)="onSubmit()">Save
            </button>
        </div>
    </form>
</div>